export * from './request';
export * from './response';

export { BetSlipPaymentType } from './BetSlipPaymentType';
export { BetSlipTypes } from './BetSlipTypes';
export { BaseTip } from './BaseTip';